import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';

import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

import { UserGridConfig } from 'src/app/shared/models';
import { AbstractPageForm } from 'src/app/shared/pages/page-form.abstract';

@Component({
	selector: 'pk-broker-contract-edit-user-grid-config',
	templateUrl: './contract-edit-user-grid-config.component.html',
	styleUrls: ['./contract-edit-user-grid-config.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class ContractEditUserGridConfigModalComponent extends AbstractPageForm {
	public onSuccess: Subject<UserGridConfig> = new Subject();

	public userGridConfig: UserGridConfig;

	constructor(
		public activeModal: BsModalRef,
		private fb: FormBuilder,
	) {
		super();
		this.submitText = 'Save';
		this.submittingText = 'Saving...';
	}

	public async loadPageData(): Promise<void> {}

	public getForm() {
		return this.fb.group({
			name: [this.userGridConfig.name, [Validators.required]],
			isDefault: this.userGridConfig.isDefault,
		});
	}

	protected async onFormSubmitted() {
		this.userGridConfig.name = this.form.name.value;
		this.userGridConfig.isDefault = this.form.isDefault.value;
		this.onSuccess.next(this.userGridConfig);
		this.activeModal.hide();
	}
}
